import React, { useState } from 'react';
import { Users, MapPin, TrendingUp, Plus, Search, Filter, Edit, Eye, Mail, Phone, Download } from 'lucide-react';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../../components/ui/Table';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
export function CooperativeList() {
  const cooperatives = [{
    id: 1,
    name: 'Koperasi Maju Jaya',
    location: 'Bogor, Jawa Barat',
    contact: '+62 812-3456-7890',
    orders: 156,
    spent: 45000000,
    avgOrder: 288000,
    creditLimit: 50000000,
    outstanding: 12500000,
    status: 'active',
    lastOrder: '2 hari lalu'
  }, {
    id: 2,
    name: 'Koperasi Sejahtera',
    location: 'Bandung, Jawa Barat',
    contact: '+62 813-9876-5432',
    orders: 132,
    spent: 38000000,
    avgOrder: 288000,
    creditLimit: 40000000,
    outstanding: 8500000,
    status: 'active',
    lastOrder: '1 hari lalu'
  }, {
    id: 3,
    name: 'Tani Makmur',
    location: 'Sukabumi, Jawa Barat',
    contact: '+62 815-2468-1357',
    orders: 98,
    spent: 28000000,
    avgOrder: 286000,
    creditLimit: 30000000,
    outstanding: 5200000,
    status: 'active',
    lastOrder: '5 hari lalu'
  }, {
    id: 4,
    name: 'Desa Mandiri',
    location: 'Cianjur, Jawa Barat',
    contact: '+62 817-5555-8888',
    orders: 87,
    spent: 24000000,
    avgOrder: 276000,
    creditLimit: 25000000,
    outstanding: 3800000,
    status: 'active',
    lastOrder: '3 hari lalu'
  }];
  return <div className="space-y-6" data-id="element-396">
      {/* Header */}
      <div className="flex justify-between items-start" data-id="element-397">
        <div data-id="element-398">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-399">
            Manajemen Koperasi
          </h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-400">
            Kelola mitra koperasi dan pantau performa
          </p>
        </div>
        <div className="flex gap-2" data-id="element-401">
          <Button variant="outline" icon={<Download className="w-4 h-4" data-id="element-403" />} data-id="element-402">
            Ekspor Data
          </Button>
          <Button variant="primary" icon={<Plus className="w-4 h-4" data-id="element-405" />} data-id="element-404">
            Tambah Koperasi
          </Button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-4 gap-4" data-id="element-406">
        <Card className="p-4 border-l-4 border-l-blue-500" data-id="element-407">
          <p className="text-sm text-slate-600 mb-1" data-id="element-408">Total Koperasi</p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-409">127</p>
          <p className="text-xs text-green-600 mt-1" data-id="element-410">+4 bulan ini</p>
        </Card>
        <Card className="p-4 border-l-4 border-l-green-500" data-id="element-411">
          <p className="text-sm text-slate-600 mb-1" data-id="element-412">Total Transaksi</p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-413">Rp 135M</p>
          <p className="text-xs text-green-600 mt-1" data-id="element-414">+12% vs bulan lalu</p>
        </Card>
        <Card className="p-4 border-l-4 border-l-violet-500" data-id="element-415">
          <p className="text-sm text-slate-600 mb-1" data-id="element-416">Rata-rata Order</p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-417">Rp 285K</p>
          <p className="text-xs text-slate-500 mt-1" data-id="element-418">Per transaksi</p>
        </Card>
        <Card className="p-4 border-l-4 border-l-amber-500" data-id="element-419">
          <p className="text-sm text-slate-600 mb-1" data-id="element-420">Outstanding</p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-421">Rp 30M</p>
          <p className="text-xs text-slate-500 mt-1" data-id="element-422">Total tagihan</p>
        </Card>
      </div>

      {/* Search & Filter */}
      <div className="flex gap-2" data-id="element-423">
        <div className="relative flex-1" data-id="element-424">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-425" />
          <input type="text" placeholder="Cari koperasi berdasarkan nama atau lokasi..." className="w-full pl-10 pr-4 py-2 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-426" />
        </div>
        <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-lg text-sm font-medium text-slate-600 hover:bg-slate-50" data-id="element-427">
          <Filter className="w-4 h-4" data-id="element-428" />
          Filter
        </button>
      </div>

      {/* Cooperative Table */}
      <Card className="overflow-hidden" data-id="element-429">
        <Table data-id="element-430">
          <TableHeader data-id="element-431">
            <TableRow data-id="element-432">
              <TableHead data-id="element-433">Koperasi</TableHead>
              <TableHead data-id="element-434">Lokasi</TableHead>
              <TableHead data-id="element-435">Total Pesanan</TableHead>
              <TableHead data-id="element-436">Total Belanja</TableHead>
              <TableHead data-id="element-437">Rata-rata Order</TableHead>
              <TableHead data-id="element-438">Credit Limit</TableHead>
              <TableHead data-id="element-439">Outstanding</TableHead>
              <TableHead data-id="element-440">Status</TableHead>
              <TableHead className="text-right" data-id="element-441">Aksi</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody data-id="element-442">
            {cooperatives.map(coop => <TableRow key={coop.id} data-id="element-443">
                <TableCell data-id="element-444">
                  <div className="flex items-center gap-3" data-id="element-445">
                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-446">
                      <Users className="w-5 h-5 text-blue-600" data-id="element-447" />
                    </div>
                    <div data-id="element-448">
                      <p className="font-bold text-slate-900" data-id="element-449">{coop.name}</p>
                      <p className="text-xs text-slate-500" data-id="element-450">{coop.contact}</p>
                    </div>
                  </div>
                </TableCell>
                <TableCell data-id="element-451">
                  <div className="flex items-center gap-1 text-slate-600" data-id="element-452">
                    <MapPin className="w-4 h-4 flex-shrink-0" data-id="element-453" />
                    <span className="text-sm" data-id="element-454">{coop.location}</span>
                  </div>
                </TableCell>
                <TableCell data-id="element-455">
                  <div data-id="element-456">
                    <p className="font-bold text-slate-900" data-id="element-457">{coop.orders}</p>
                    <p className="text-xs text-slate-500" data-id="element-458">{coop.lastOrder}</p>
                  </div>
                </TableCell>
                <TableCell className="font-bold text-blue-600" data-id="element-459">
                  Rp {(coop.spent / 1000000).toFixed(1)}Jt
                </TableCell>
                <TableCell className="text-slate-600" data-id="element-460">
                  Rp {(coop.avgOrder / 1000).toFixed(0)}K
                </TableCell>
                <TableCell className="text-slate-600" data-id="element-461">
                  Rp {(coop.creditLimit / 1000000).toFixed(0)}Jt
                </TableCell>
                <TableCell data-id="element-462">
                  <div data-id="element-463">
                    <p className="font-bold text-amber-600" data-id="element-464">
                      Rp {(coop.outstanding / 1000000).toFixed(1)}Jt
                    </p>
                    <p className="text-xs text-slate-500" data-id="element-465">
                      {(coop.outstanding / coop.creditLimit * 100).toFixed(0)}
                      % terpakai
                    </p>
                  </div>
                </TableCell>
                <TableCell data-id="element-466">
                  <Badge variant="success" data-id="element-467">Aktif</Badge>
                </TableCell>
                <TableCell data-id="element-468">
                  <div className="flex justify-end gap-1" data-id="element-469">
                    <button className="p-2 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors" data-id="element-470">
                      <Eye className="w-4 h-4" data-id="element-471" />
                    </button>
                    <button className="p-2 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors" data-id="element-472">
                      <Edit className="w-4 h-4" data-id="element-473" />
                    </button>
                    <button className="p-2 text-slate-400 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors" data-id="element-474">
                      <Phone className="w-4 h-4" data-id="element-475" />
                    </button>
                    <button className="p-2 text-slate-400 hover:text-violet-600 hover:bg-violet-50 rounded-lg transition-colors" data-id="element-476">
                      <Mail className="w-4 h-4" data-id="element-477" />
                    </button>
                  </div>
                </TableCell>
              </TableRow>)}
          </TableBody>
        </Table>
      </Card>
    </div>;
}